import { render, staticRenderFns } from "./inflections-table-prerendered.vue?vue&type=template&id=ab9ccf00&"
import script from "./inflections-table-prerendered.vue?vue&type=script&lang=js&"
export * from "./inflections-table-prerendered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ab9ccf00', component.options)
    } else {
      api.reload('ab9ccf00', component.options)
    }
    module.hot.accept("./inflections-table-prerendered.vue?vue&type=template&id=ab9ccf00&", function () {
      api.rerender('ab9ccf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections-table-prerendered.vue"
export default component.exports